export enum SettingKey {
  CancelledEmail = 'CancelledEmail',
  CompletedEmail = 'CompletedEmail',
  DefaultFromEmail = 'DefaultFromEmail',
  DevEmailRecipient = 'DevEmailRecipient',
  DeveloperEmail = 'DeveloperEmail',
  DispatchedEmail = 'DispatchedEmail',
  InFlightEmail = 'InFlightEmail',
  LandedEmail = 'LandedEmail',
  SubmittedEmail = 'SubmittedEmail',
  MaxPassengers = 'MaxPassengers',
  PlanCategoryList = 'PlanCategoryList',
  MaxStructures = 'MaxStructures',
  MaxWorkLocation = 'MaxWorkLocation',
  MaxEquipments = 'MaxEquipments',
  MaxTieLinesCircuits = 'MaxTieLinesCircuits',
  FuelCycles = 'FuelCycles',
  LandingCycles = 'LandingCycles',
  MaxMultiFlights = 'MaxMultiFlights',
  MaxCNDWONumbers = 'MaxCNDWONumbers'
}
